import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { Distributor, DistributorMutation, Warehouse, WarehouseMutation, WarehouseType, WarehouseTypeMutation } from './models/distributor';
import { RequestPayload } from './types';

const LIST_ENDPOINT = 'distributor/list/';
const CREATE_ENDPOINT = 'distributor/create/';
const UPDATE_ENDPOINT = 'distributor/update/';
const DELETE_ENDPOINT = 'distributor/delete/';

const LIST_WAREHOUSES_ENDPOINT = '/distributor/warehouse/list/';
const CREATE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/create/';
const UPDATE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/update/';
const DELETE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/delete/';

const LIST_WAREHOUSE_TYPES_ENDPOINT = '/distributor/warehouse_type/list/';
const CREATE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/create/';
const UPDATE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/update/';
const DELETE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/delete/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getDistributors: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Distributor>>>(LIST_ENDPOINT, payload, config),
  createDistributor: (payload: DistributorMutation) =>
    instance.post<ApiResponse<Distributor>>(CREATE_ENDPOINT, payload, config),
  updateDistributor: (payload: DistributorMutation) =>
    instance.put<ApiResponse<Distributor>>(UPDATE_ENDPOINT, payload, config),
  deleteDistributor: (payload: { id: number; is_active: boolean }) =>
    instance.post<ApiResponse<any>>(DELETE_ENDPOINT, payload, config),
  getWarehouses: () =>
    instance.get<ApiResponse<Warehouse[]>>(LIST_WAREHOUSES_ENDPOINT, config),
  createWarehouse: (payload: WarehouseMutation) =>
    instance.post<ApiResponse<Warehouse>>(CREATE_WAREHOUSE_ENDPOINT, payload, config),
  updateWarehouse: (payload: WarehouseMutation) =>
    instance.put<ApiResponse<Warehouse>>(UPDATE_WAREHOUSE_ENDPOINT, payload, config),
  deleteWarehouse: (id: number) =>
    instance.post<ApiResponse<Warehouse>>(DELETE_WAREHOUSE_ENDPOINT, { ...config, data: { id }, headers: { ...config.headers, 'cache-force': true } }),
  getWarehouseTypes: () =>
    instance.get<ApiResponse<WarehouseType[]>>(LIST_WAREHOUSE_TYPES_ENDPOINT, { ...config, headers: { ...config.headers, 'cache-force': true } }),
  createWarehouseType: (payload: WarehouseTypeMutation) =>
    instance.post<ApiResponse<WarehouseType>>(CREATE_WAREHOUSE_TYPE_ENDPOINT, payload, config),
  updateWarehouseType: (payload: WarehouseTypeMutation) =>
    instance.put<ApiResponse<WarehouseType>>(UPDATE_WAREHOUSE_TYPE_ENDPOINT, payload, config),
  deleteWarehouseType: (id: number) =>
    instance.post<ApiResponse<WarehouseType>>(DELETE_WAREHOUSE_TYPE_ENDPOINT, { ...config, data: { id } }),
});
